import React, { useState, useRef, useEffect } from "react"
import { selectLoading } from "modules/notification"
import { getStockoutReceiverDropdown } from "modules/stockflow/redux"
import { useSelector, useDispatch } from "react-redux"
import { cloneDeep } from "lodash"
import StockoutReceiverSelectComponent from "./stockoutReceiverSelect.component"
import StockoutReceiverSelectPanelComponent from "./stockoutReceiverSelectPanel.component"

function StockoutReceiverSelectContainer({
  handleChange,
  disabled,
  value,
  styles, 
  textStyles,
  placeholder,
  type,
  dealerUuid,
}) {
  const isFetching = useSelector(state => selectLoading(state, getStockoutReceiverDropdown.typePrefix))
  const stockoutReceiverDropdown = useSelector((state) => state.stockflowStockout.stockoutReceiverDropdown)
  const lang = useSelector((state) => state.constant.languages)
  const [open, setOpen] = useState(false)
  const [isOpenList] = useState(false)
  const anchorRef = useRef(null)
  const prevOpen = useRef(open)
  const prevOpenList = useRef(isOpenList)
  const [selectAll, setSelectAll] = useState(false)
  const [search, setSearch] = useState("")
  const dispatch = useDispatch()

  useEffect(() => {
    let param = { search, type }
    if (dealerUuid) {
      param.stockout_from_dealer = dealerUuid
    }
    dispatch(getStockoutReceiverDropdown(param))
  }, [search, type, dispatch, dealerUuid])

  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  useEffect(() => {
    if (prevOpenList.current === true && isOpenList === false) {
      anchorRef.current.focus()
    }

    prevOpenList.current = isOpenList
  }, [isOpenList])

  useEffect(() => {
    setSelectAll(value.length === stockoutReceiverDropdown.length)
  }, [value, stockoutReceiverDropdown])

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
    setSearch("")
  }

  const handleSelectAll = async () => {
    if(!selectAll){
      let selectedReceiver = stockoutReceiverDropdown.map(p => {
        return p.id
      })
      handleChange(selectedReceiver)
    }else{
      handleChange([])
    }
  }

  const handleSelectReceiver = (receiver) => {
    let temp = cloneDeep(value)

    if(temp.findIndex(t => t === receiver.id) >= 0){
      temp = temp.filter( t => t !== receiver.id )
    }else{
      temp.push(receiver.id)
    }
    handleChange(temp)
  }

  const handleSearch = (value) => {
    setSearch(value)
  }

  return (
    <>
      <StockoutReceiverSelectComponent
        anchorRef={anchorRef}
        disabled={disabled}
        value={value}
        handleClick={handleOpen}
        styles={styles}
        textStyles={textStyles}
        placeholder={placeholder}
        lang={lang}
      />
      <StockoutReceiverSelectPanelComponent
        selectAll={selectAll}
        value={value}
        anchorRef={anchorRef}
        open={open}
        isOpenList={isOpenList}
        handleClose={handleClose}
        isFetching={isFetching}
        stockoutReceiverDropdown={stockoutReceiverDropdown}
        handleSelectAll={handleSelectAll}
        handleSelectReceiver={handleSelectReceiver}
        handleSearch={handleSearch}
        lang={lang}
      />
    </>
  )
}

export default StockoutReceiverSelectContainer